// extracted by mini-css-extract-plugin
export default {"container":"lawyer_snippet-module__container--5P5kB"};